module.exports = __webpack_public_path__ + "static/dashboard_production-32682f9ab775bfff88b2e7789c1d5f12.png";